import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatIconModule } from '@angular/material/icon';
import { BehaviorSubject, debounceTime, distinctUntilChanged, Subject, takeUntil } from 'rxjs';
import { Camera } from '../../interfaces/camera';
import { CameraSelectionAction, CameraSelectionEvent } from '../../interfaces/site-selector';

@Component({
  selector: 'lib-site-list',
  imports: [MatFormFieldModule, ReactiveFormsModule,MatInputModule,MatIconModule ],
  templateUrl: './site-list.html',
  styleUrl: './site-list.scss'
})

export class SiteList implements OnInit {

  private destroy$ = new Subject<void>();

  /**
   * List of cameras passed in from the main lib component
   */
  @Input() cameraList!:Camera[];
  /**
   * Is the site list container currently shown
   */
  @Input() siteListActive : boolean = false;
  /**
   * Site List Container close event relay to parent
   */
  @Output() onSiteListClose: EventEmitter<boolean> = new EventEmitter();
  /**
   * Emit Selection update on the site list container to the parent
   */
  @Output() onSelectionUpdate: EventEmitter<CameraSelectionEvent> = new EventEmitter();
  /**
   * Camera List Input
   */
  @Input() searchList : Camera[] = [];
  /**
   * Behavior Subject to help with resetting the search list
   */
  @Input() searchList$!: BehaviorSubject<boolean>;
  searchControl = new FormControl('');

  ngOnInit(){
     this.searchList$
     .pipe(takeUntil(this.destroy$))
     .subscribe((resetList: boolean) => {
        if(resetList){
          this.onSearch();
        }
    });
    this.resetSearchList();
    this.searchControl.valueChanges
      .pipe(takeUntil(this.destroy$))
      .pipe(debounceTime(300), distinctUntilChanged())
      .subscribe(() => this.onSearch());
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  resetSearchList(){
    this.searchList = JSON.parse(JSON.stringify(this.cameraList));
  }

  /**
   * Filter the camera results based on the camera name search
   * @returns 
   */
  onSearch() {
    const value = this.searchControl.value?.trim();
    if (!value) {
      // Reset full user list
      this.resetSearchList();
      return;
    }

    this.searchList = this.cameraList.filter((el:Camera)=> el.name.includes(value));
    return this.searchList;
  }

  /**
   * Clear the text from the mat input for search
   */
  clearSearch() {
    this.searchControl.setValue('');
  }

  /**
   * Event to react to close button click
   */
  closeSiteListContainer(){
    this.siteListActive = false;
    this.onSiteListClose.emit(false);
  }

  /**
   * Event to react to camera selection
   * Emits the full new cameraList with onSelectionUpdate 
   * @param {Camera} camera 
   */
  onSiteSelect(camera:Camera){
    let type!: CameraSelectionAction;
    if(camera.selected) {
      //remove the camera
      type = 'Removal';
      camera.selected = false;
    }
    else{
      //add the camera to the selected list
      type = 'Selection';
      camera.selected = true;
    }
    const selectionObject: CameraSelectionEvent = {
      type, camera
    }
    this.onSelectionUpdate.emit(selectionObject)
  }

}
